// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__Vr79Q","footer":"ModalError_footer__1gSKm"};